import { DateTime } from "luxon";
import { z } from "zod";

export const TimeOfDayRegex = /^(2[0-3]|[01]?[0-9]):([0-5]?[0-9])$/;

export const TimeOfDaySchema = z.string().regex(TimeOfDayRegex);

export type TimeOfDay = z.infer<typeof TimeOfDaySchema>;

export function timeOfDayToDateTime(timeOfDay: TimeOfDay, date?: DateTime): DateTime {
  const match = TimeOfDayRegex.exec(timeOfDay);
  if (!match) {
    return DateTime.invalid(`invalid TimeOfDay: ${JSON.stringify(timeOfDay)}`);
  }
  const hour = parseInt(match[1], 10);
  const minute = parseInt(match[2], 10);
  if (date) {
    return DateTime.fromObject({
      year: date.year,
      month: date.month,
      day: date.day,
      hour,
      minute,
    });
  } else {
    return DateTime.fromObject({ hour, minute });
  }
}
